import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=ee041cb6&"
import script from "./TagSelect.vue?vue&type=script&lang=ts&"
export * from "./TagSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TagSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports